import CardWithTopLine from './CardWithTopLine';

export default CardWithTopLine;
